import React, { useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import {
  BannerSection,
  VideoWrapper,
  StyledVideo,
  Overlay,
  Content,
  Title,
  Subtitle,
  BannerButton,
  Note
} from './HeroBanner.styles'

const VIDEO_SRC = `${process.env.CDN_URL}/public/landingpagev2/videos/hero-desktop.mp4`

const HeroBanner: React.FC = () => {
  const { t } = useTranslation()
  const videoRef = useRef<HTMLVideoElement | null>(null)
  const bannerRef = useRef<HTMLElement | null>(null)

  useEffect(() => {
    const video = videoRef.current
    if (!video) return

    const handleVisibility = (entries: IntersectionObserverEntry[]) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          video.play()
        } else {
          video.pause()
        }
      })
    }

    const observer = new window.IntersectionObserver(handleVisibility, {
      threshold: 0.3
    })
    if (bannerRef.current) {
      observer.observe(bannerRef.current)
    }
    return () => {
      observer.disconnect()
    }
  }, [])

  return (
    <BannerSection ref={bannerRef}>
      <VideoWrapper>
        <StyledVideo
          ref={videoRef}
          src={VIDEO_SRC}
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          tabIndex={-1}
          aria-hidden="true"
        />
        <Overlay />
        <Content>
          <Title>{t('landingV2.heroBanner.title')}</Title>
          <Subtitle>{t('landingV2.heroBanner.subtitle')}</Subtitle>
          <BannerButton>{t('landingV2.heroBanner.button')}</BannerButton>
          <Note>{t('landingV2.heroBanner.note')}</Note>
        </Content>
      </VideoWrapper>
    </BannerSection>
  )
}

export default HeroBanner
